import styled from 'styled-components'

import { List, ListItem, Typography } from '@material-ui/core'

import colors from '@galo-monitor/styles/colors'

export const Container = styled.div`
  display: flex;
  gap: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const ListProperty = styled(List)`
  display: flex;
  gap: 5px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const ListItemProperty = styled(ListItem)`
  width: 28em;
  padding: 13px 23px;
  border-radius: 5px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: ${ colors.white };
`

export const LinkStyledText = styled(Typography)`
  color: ${ colors.link };
  cursor: pointer;
  &:hover {
    opacity: 0.9;
    text-decoration: underline;
  }
`

export const TopRightButtonContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 20px;
`
